import useDocumentMeta from "@/hooks/useDocumentMeta";
import HeroCarousel from "@/pages/home/components/HeroCarousel";
import CategoryShortcuts from "@/pages/home/components/CategoryShortcuts";
import FeaturedTabs from "@/pages/home/components/FeaturedTabs";
import ShortStrip from "@/pages/home/components/ShortStrip";
import IntroSection from "@/pages/home/components/IntroSection";

export default function Home() {
  useDocumentMeta({
    title: "逼特逼视频 - 高清在线视频观看与丰富短视频内容",
    description:
      "逼特逼视频为您提供多样化的视频内容，包括热门电影、电视剧及短视频，满足用户在线视频观看和视频分享需求。畅享优质视觉体验，实时更新精彩作品。",
    keywords: "逼特逼视频,在线视频,高清视频,影视剧,短视频,视频平台,视频分享",
  });

  return (
    <>
      <HeroCarousel />
      <CategoryShortcuts />
      <FeaturedTabs />
      <ShortStrip />
      <IntroSection />
    </>
  );
}